import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useEffect, useMemo, useState } from 'react'
import { useColorContext } from '../../context/ColorContext'

import classNames from 'classnames'
import searchIcon from '../../icons/search.svg'
import CleanIcon from '../../icons/CleanIcon/CleanIcon'
import './ Header.scss'
import Logo from '../../icons/Logo/Logo'
import setFavicon from '../../icons/Favicon/dynamicFavicon'
// import updateFavicon, { animateFavicon } from '../../icons/Favicon/dynamicFavicon'

export default function Header() {
	const { colors, resetToDefault } = useColorContext()
	const navigate = useNavigate()
	const location = useLocation()
	const { keyword } = useParams()
	const [query, setQuery] = useState('')

	useEffect(() => {
		setQuery(keyword || '')
	}, [keyword])

	const logoColors = useMemo(() => {
		if (colors.length >= 2) {
			return colors
				.slice()
				.sort(() => 0.5 - Math.random())
				.slice(0, 2)
		}
		return Array.from({ length: 2 }, () => '#778a99')
	}, [colors])

	useEffect(() => {
		if (logoColors.length >= 2) {
			setFavicon(logoColors[0], logoColors[1])
		}
	}, [logoColors])


	const onSearch = () => {
		const trimmed = query.trim()
		if (trimmed) {
			if (decodeURIComponent(location.pathname.slice(1)) === trimmed) {
				window.location.reload()
			} else {
				navigate(`/${encodeURIComponent(trimmed)}`)
			}
		} else if (location.pathname !== '/') {
			navigate('/')
		}
	}

	const goHome = () => {
		setQuery('')
		resetToDefault()
		navigate('/')
	}

	return (
		<header
			className={classNames('header', {
				header__keyword: !!keyword,
			})}
		>
			<h1 onClick={goHome} className='logo'>
				<span className='logo__word'>Kolir</span>
				{logoColors.length ? (
					<Logo color1={logoColors[0]} color2={logoColors[1]} />
				) : (
					<Logo />
				)}
				<span className='logo__word'>in</span>
				{/* {LOGO_TEXT.map((word, i) => (
					<span
						key={i}
						className='colored'
						style={{ '--active-color': logoColors[i] }}
					>
						{word}
					</span>
				))} */}
			</h1>

			{!!keyword && (
				<div className='search__input-wrapper'>
					<img src={searchIcon} alt='search__icon' className='search__icon' />
					<input
						type='text'
						className='search__input'
						value={query}
						onChange={e => setQuery(e.target.value)}
						placeholder={'ліс, вода, пустеля тощо...'}
						onKeyDown={e => e.key === 'Enter' && onSearch()}
					/>
					{query && (
						<CleanIcon color={logoColors[1]} click={() => setQuery('')} />
					)}
				</div>
			)}

			{!!keyword && (
				<h4 onClick={goHome} className='suport'>
					Підтримати проєкт
				</h4>
			)}
		</header>
	)
}
